import _ from 'lodash'
import * as service from '../services'

export const INITIAL_FORM_STATE = {
  email: '',
  password_login: '',
}

export const OTHERS_STATE = {
  enfermOtra: '',
  enfUbicOtra: '',
  plgOtras: '',
  plgUbicOtros: '',
  probFisicosOtros: '',
  riesgoOtros: '',
  recomOtros: '',
}

export function getInitialState(items_formik) {
  let initial_state = {}
  items_formik.forEach(o => {
    let ObjNew = {}
    ObjNew[`${o.name}`] = o.initvalue
    initial_state = { ...initial_state, ...ObjNew }
  })
  return initial_state
}

export function optionListByKey(key, attributes) {
  const metaFeature = _.find(attributes, obj => obj.key === key)
  const { u_medida } = metaFeature
  const optionsUnit = u_medida.split(', ')
  return _.map(optionsUnit, value => _.trim(value))
}

export function getOptionFromTypeCategory(key, categoryTypeAll) {
  const optionsByKey = _.filter(categoryTypeAll, ['key', key])
  let optionsFormat = {}
  optionsByKey.forEach(o => {
    if (o.habilitado.data[0] && o.enum) {
      let newObj = {}
      newObj[o.id_ctgT] = o.enum
      optionsFormat = { ...optionsFormat, ...newObj }
    }
  })
  return optionsFormat
}

export function optionsForSchema(key, categoryTypeAll) {
  const option = getOptionFromTypeCategory(key, categoryTypeAll)
  return Object.keys(option)
}

function getListChangeLogForFeature(metafeatures, attr, values, coodinates) {
  let objToCreation
  _.forEach(metafeatures, obj => {
    const currentValue = Boolean(values[obj.key]) ? values[obj.key] : null
    const stateInitial = _.find(attr, o => o.metaFeature.key === obj.key)
    const initialValue = Boolean(stateInitial?.value) ? stateInitial?.value : null

    // Manejo especial para coordenadas
    if (_.includes(['longX', 'latY'], obj.key)) {
      // Usar coordenadas del formulario (values) si existen
      const formCoordValue = currentValue
      const formCoordNum = formCoordValue ? parseFloat(formCoordValue) : null
      const initialNum = initialValue ? parseFloat(initialValue) : null

      // Solo actualizar si la coordenada del formulario cambió respecto a la inicial
      if (formCoordNum !== null && formCoordNum !== initialNum) {
        let newObj = {}
        newObj[obj.key] = {
          id: obj.id_mc,
          value: formCoordValue,
          verified: null,
        }
        objToCreation = { ...objToCreation, ...newObj }
      }
    } else if (initialValue !== currentValue) {
      // Para otros campos, actualizar si cambió
      let newObj = {}
      newObj[obj.key] = { id: obj.id_mc, value: currentValue, verified: null }
      objToCreation = { ...objToCreation, ...newObj }
    }
  })
  return objToCreation
}

export function getListToGeneralCondition(stateInitial, temporal, values) {
  let objToCreation
  const RIESGOS_OTROS = 91
  const OTHERS_ELEMENTS = [86, 87, 88, 89, 90, 91, 92]
  const list1 = _.filter(temporal, o => _.includes([1, 7], o.category))
  const list2 = _.filter(temporal, o => !_.includes([1, 7], o.category))

  _.forEach(list1, object => {
    const currentId = values[object.name]
    if (currentId) {
      // NO CHANGE THE SIMPLE OPERATOR != TO MODE EXTRICT !==
      if (object.initvalue != currentId) {
        let newObj = {}
        if (RIESGOS_OTROS === object.typecategory)
          newObj[object.name] = {
            categorytype: object.typecategory,
            value: currentId,
          }
        else
          newObj[object.name] = {
            categorytype: parseInt(currentId, 10),
            beforeValue: object.initvalue,
          }
        objToCreation = { ...objToCreation, ...newObj }
      }
    }
  })

  _.forEach(list2, object => {
    const currentTypeCategory = object.typecategory
    if (!_.some(stateInitial, ['typecategory', currentTypeCategory])) {
      let newObj = {}
      newObj[object.name] = { categorytype: currentTypeCategory, value: object.initvalue }
      objToCreation = { ...objToCreation, ...newObj }
    } else {
      if (_.includes(OTHERS_ELEMENTS, currentTypeCategory)) {
        const initial = _.find(stateInitial, ['typecategory', currentTypeCategory])
        if (initial.initvalue !== object.initvalue) {
          let newObj = {}
          newObj[object.name] = {
            categorytype: currentTypeCategory,
            value: object.initvalue,
          }
          objToCreation = { ...objToCreation, ...newObj }
        }
      }
    }
  })
  return objToCreation
}

export function getListItemsToRemove(stateInitial, temporal, value) {
  let objToCreation
  const onlyItemsChip = _.filter(stateInitial, o => !_.includes([1, 7], o.category))
  const itemOtherRiskStateInit = _.find(stateInitial, ['typecategory', 91])

  _.forEach(onlyItemsChip, object => {
    const currentTypeCategory = object.typecategory
    if (!_.some(temporal, ['typecategory', currentTypeCategory])) {
      let newObj = {}
      newObj[object.name] = currentTypeCategory
      objToCreation = { ...objToCreation, ...newObj }
    }
  })

  if (Boolean(itemOtherRiskStateInit.initvalue)) {
    if (!Boolean(value.riesgoOtros)) {
      const newObj = { riesgoOtros: 91 }
      objToCreation = { ...objToCreation, ...newObj }
    }
  }
  return objToCreation
}

async function addToDatabase(id, listInconveToStored, token) {
  if (!listInconveToStored) return { stored: null }
  const resUpdateInconv = await service.createAndUpdateInconvenienceLog(
    id,
    listInconveToStored,
    token
  )
  if (_.some(resUpdateInconv.actions, ['typeActions', 'Not created']))
    return {
      stored: false,
      message: 'Algún elemento falló al guardarse. Inténtelo nuevamente.',
    }
  return { stored: true }
}

async function removeInDatabase(id, listToRemove, token) {
  if (!listToRemove) return { stored: null }
  const responseDelete = await service.disableInconveniences(id, listToRemove, token)
  if (_.some(responseDelete.actions, ['typeAction', 'Not deleted']))
    return {
      stored: false,
      message: 'Algún elemento falló al eliminarse. Inténtelo nuevamente.',
    }
  return { stored: true }
}

async function addFeaturesToBD(id, listFeatureToStored, token) {
  try {
    if (!Boolean(listFeatureToStored)) return { stored: null }
    const responseFeatures = await service.createFeaturesByKey(
      id,
      listFeatureToStored,
      token
    )

    if (_.some(responseFeatures.actions, ['typeAction', 'error'])) {
      const error = _.find(responseFeatures.actions, ['typeAction', 'error'])
      if (error?.key === 'longX') {
        const newList = listFeatureToStored['longX']
        const respCreatedFeature = await service.createAFeature(id, newList, token)
        if (respCreatedFeature === 'created') return { stored: true }
        else
          return {
            stored: false,
            message: 'Algún elemento falló al guardarse. Inténtelo nuevamente.',
          }
      }
    }

    if (_.some(responseFeatures.actions, ['typeAction', 'notCreated']))
      return {
        stored: false,
        message: 'Algún elemento falló al guardarse. Inténtelo nuevamente.',
      }
    return { stored: true }
  } catch (err) {
    return { stored: false, message: 'Error al guardar en la base de datos' }
  }
}

function getListTreeIdentity(values, properties, groupsFields) {
  const {
    specieField: specie_,
    siteField,
    siteAcronym,
    sectionField,
    pseudonymField,
  } = groupsFields
  const { error: errPseudonym, selected: selectedPs } = pseudonymField
  const { parish_, typeSite_, sitePlace_, site_ } = values
  const { section_, alive_, treeVerified_, recorded_, commit_ } = values

  const { alive, commit, recorded, treeVerified, site, specie } = properties
  const { parish, zoneType: typeSite, siteType: sitePlace, siteAcronym: siteAcronymInitial } = site
  const { id: specieId } = specie

  const aliveINT = parseInt(alive_, 10)
  const treeVerifiedINT = parseInt(treeVerified_, 10)
  const defaultU = undefined
  // let formatedDate = date_.toISOString().split('T')[0]

  function getFieldsTreeTable() {
    const dataForTreeTable = [
      {
        specieId: !_.eq(specie_.selected.id, specieId.toString())
          ? specie_.selected.id
          : defaultU,
      },
      { alive: !_.eq(Boolean(aliveINT), alive) ? Boolean(aliveINT) : defaultU },
      {
        treeVerified: !_.eq(Boolean(treeVerifiedINT), treeVerified)
          ? Boolean(treeVerifiedINT)
          : defaultU,
      },
      { recorded: !_.eq(recorded_, recorded) ? recorded_ : defaultU },
      { commit: !_.eq(commit_, commit) ? commit_ : defaultU },
      // {
      //   date: !_.eq(date_.getTime(), new Date(dateLog).getTime())
      //     ? formatedDate
      //     : defaultU,
      // },
    ]

    let dataToStored = {}
    _.forEach(dataForTreeTable, obj => {
      const valueToObj = Object.values(obj)[0]
      if (valueToObj === defaultU) return
      dataToStored = { ...dataToStored, ...obj }
    })
    return dataToStored
  }

  function getFieldsSiteTable() {
    const newSite = siteField.selected
    const newSection = sectionField.selected
    const newAcronym = siteAcronym.selected

    const formatSite = typeSite ?? '#'
    const formatSitePlace = sitePlace ?? '#'
    const formatParish = parish ?? '#'

    const siteTable = [
      { siteName: !_.eq(newSite, site_) ? newSite : defaultU },
      { typeSite: !_.eq(typeSite_, formatSite) ? typeSite_ : defaultU },
      { sitePlace: !_.eq(sitePlace_, formatSitePlace) ? sitePlace_ : defaultU },
      { section: !_.eq(newSection, section_) ? newSection : defaultU },
      { siteAcronym: !_.eq(newAcronym, siteAcronymInitial) ? newAcronym : defaultU },
      { parishId: !_.eq(parish_, formatParish.id) ? parish_ : defaultU },
    ]

    function numberElementsToStore() {
      let dataToStored = {}
      _.forEach(siteTable, obj => {
        const valueToObj = Object.values(obj)[0]
        if (valueToObj === defaultU) return
        dataToStored = { ...dataToStored, ...obj }
      })
      return Object.keys(dataToStored).length
    }

    let newObj = {}
    const nroElem = numberElementsToStore()
    if (Boolean(nroElem)) {
      return {
        siteName: newSite,
        typeSite: typeSite_,
        sitePlace: sitePlace_,
        section: newSection,
        siteAcronym: newAcronym,
        parishId: parish_,
      }
    }
    return newObj
  }

  function getFieldsPseudonymTable() {
    const inputPseudonym = !errPseudonym ? [...selectedPs] : []
    // New = user-typed suggestions (no id); fixed items from any species have id
    const newElements = inputPseudonym.filter(item => !item.id)
    return { new: newElements, remove: [] }
  }

  const dataToStoredTreeTable = getFieldsTreeTable()
  const dataToStoredSiteTable = getFieldsSiteTable()
  const dataToStoredPseudonymTable = getFieldsPseudonymTable()

  return [dataToStoredTreeTable, dataToStoredSiteTable, dataToStoredPseudonymTable]
}

async function updateTreeTable(id, onlyTreeTable, token) {
  const existElemTreeTable = Object.keys(onlyTreeTable).length
  if (!existElemTreeTable) return { stored: null }
  const updatedResponse = await service.updateTreeTable(id, onlyTreeTable, token)
  if (updatedResponse.update === false)
    return { stored: false, message: 'Ya existe el código del árbol.' }
  if (_.includes(updatedResponse, 0))
    return {
      stored: false,
      message: 'Posible actualización fallida. Inténtelo nuevamente.',
    }
  return { stored: true }
}

async function updateSiteTable(id, onlySiteTable, token) {
  const existElemTreeTable = Object.keys(onlySiteTable).length
  if (!existElemTreeTable) return { stored: null }
  const createdSiteResponse = await service.createSiteTable(onlySiteTable, token)
  // If is 'warning' means previously existed. Update 'siteId' in tree table.
  if (_.includes(['warning', 'creation'], createdSiteResponse.typeAction)) {
    try {
      const updateTree = await service.updateTreeTable(
        id,
        {
          siteId: createdSiteResponse.id,
          acronym: `${onlySiteTable.siteAcronym}`,
        },
        token
      )
      if (_.includes(updateTree, 0))
        return {
          stored: false,
          message: 'Posible actualización fallida. Inténtelo nuevamente.',
        }
    } catch (error) {
      return {
        stored: false,
        message: 'Inténtelo nuevamente para actualizar el Nro. Árbol.',
      }
    }
    return { stored: true }
  } else return { stored: false, message: createdSiteResponse.message }
}

async function deletePseudonym(pseudonyms, token) {
  if (!pseudonyms.length) return { stored: null }
  const data = _.map(pseudonyms, 'id')
  const response = await service.deletePseudonymsOfSpecie(data, token)
  if (Array.isArray(response)) {
    if (_.every(response, ['typeAction', 'update'])) return { stored: true }
  }
  return {
    stored: false,
    message: 'Posible actualización fallida. Inténtelo nuevamente.',
  }
}

async function savePseudonym(pseudonyms, scientificName, token) {
  if (!pseudonyms.length) return { stored: null }
  const data = _.map(pseudonyms, obj => ({
    nombreComun: obj.name,
    nombreCientifico: scientificName,
  }))
  const response = await service.createPseudonyms(data, token)
  if (Array.isArray(response)) {
    if (_.every(response, ['typeAction', 'creation'])) return { stored: true }
    else {
      const notCreated = _.filter(response, ['typeAction', 'notCreated'])
      const activePseudonym = _.filter(notCreated, obj => Boolean(obj.id))
      if (activePseudonym.length) {
        const dataForActive = _.map(activePseudonym, 'id')
        const responseActivePseudonym = await service.activePseudonymsOfSpecie(
          dataForActive,
          token
        )
        if (Array.isArray(responseActivePseudonym)) {
          if (_.every(responseActivePseudonym, ['typeAction', 'update']))
            return { stored: true }
        }
      }
    }
  }
  return {
    stored: false,
    message: 'Posible actualización fallida. Inténtelo nuevamente.',
  }
}

export async function handleSaveFormik(
  values,
  properties,
  temporal,
  stateInitial,
  groupsFields,
  coordinates,
  token
) {
  const { attributes: attr, id } = properties
  const mtFeature = await service.getMetaFeaturesAll()
  const { res: metafeatures } = mtFeature
  const { label: scientificName } = groupsFields.specieField.selected

  if (!metafeatures)
    return { stored: false, message: 'Falló conexión MetaFeatures', log: mtFeature }

  // FIRST GROUP TO STORE
  const listGeneralToStored = getListTreeIdentity(values, properties, groupsFields)
  const respoUpdateTree = await updateTreeTable(id, listGeneralToStored[0], token)
  const respoUpdateSite = await updateSiteTable(id, listGeneralToStored[1], token)
  const respoSavePsdnym = await savePseudonym(
    listGeneralToStored[2].new,
    scientificName,
    token
  )
  const respoRemvPsdnym = await deletePseudonym(listGeneralToStored[2].remove, token)

  // SECOND GROUP TO STORE
  const listFeatureToStored = getListChangeLogForFeature(
    metafeatures,
    attr,
    values,
    coordinates
  )
  const respAddFeatures = await addFeaturesToBD(id, listFeatureToStored, token)

  // THIRD GROUP TO STORE
  const listInconveToStored = getListToGeneralCondition(stateInitial, temporal, values)
  const respAddInconven = await addToDatabase(id, listInconveToStored, token)

  // FOURTH GROUP TO STORE
  const listToRemove = getListItemsToRemove(stateInitial, temporal, values)
  const respDeleteIncon = await removeInDatabase(id, listToRemove, token)

  let resultSave = [
    respoUpdateTree,
    respoUpdateSite,
    respoSavePsdnym,
    respoRemvPsdnym,
    respAddFeatures,
    respAddInconven,
    respDeleteIncon,
  ]

  if (_.every(resultSave, ['stored', null]))
    return { stored: false, message: 'No se registraron cambios' }
  if (_.some(resultSave, ['stored', false])) return _.find(resultSave, ['stored', false])
  return { stored: true }
}
